import { createApp } from 'vue'
import App from './App.vue'

// 引入路由文件
import router from './router';

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
    
});

const app = createApp(App);

app.use(vuetify);
app.use(router);

app.mount('#app');